module.exports = __webpack_public_path__ + "img/vaginal-dryness.a3c2a43b.svg";